import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate } from 'react-router'
import { verifyUser } from '../redux/actions/auth'
import { getUserbrands } from '../redux/actions/brands'
import { IRootState } from '../redux/types'

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useDispatch()

  const { isAuth, user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userBrands } = useSelector((state: IRootState) => state.brand)
  if (!localStorage.getItem('isAuth') && !isAuth) {
    // localStorage.setItem('login_redirect', window.location.pathname + window.location.search);
  }

  useEffect(() => {
    const lastRequestMe: number = Number(localStorage.getItem('lastRequestMe') || '0')
    const dateNow: number = Date.now()
    const milisecondsDiff: number = dateNow - lastRequestMe
    if (milisecondsDiff > 900000 || authUser === null || !authUser?.me) dispatch(verifyUser())

    if (userBrands.length === 0) dispatch(getUserbrands())
  }, [])

  if (!localStorage.getItem('isAuth') && !isAuth) {
    return <Navigate to="/" replace />
  }

  if (authUser !== null && authUser.me === true && userBrands.length > 0) {
    return <>{children}</>
  }

  return <div>Loading...</div>
}

export default PrivateRoute
